import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { applyMeta, metaFor } from '../lib/seo';
import { siteSeo, subscribeSiteLanguages } from '../lib/siteI18n';

let version = 0;
subscribeSiteLanguages(() => { version += 1; });

// Keeps the tab title, the description, the language versions and the
// link-preview tags in step with the page being shown. Renders nothing.
// Public pages take them from their address's language (/fr/… is French);
// the app's screens from the app's language.
export default function PageMeta() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  // A language's texts arriving after the page was drawn update the head too.
  const loadedVersion = useSyncExternalStore(subscribeSiteLanguages, () => version, () => version);
  useEffect(() => { applyMeta(document, metaFor(pathname, lang, siteSeo)); }, [pathname, lang, loadedVersion]);
  return null;
}
